






































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class BaseNumberStepper extends Vue {
  @Prop({ type: Number, default: 0 })
  readonly value!: number;

  // Optional minimum value.
  @Prop({ type: Number, default: 0 })
  readonly min!: number;

  // Optional maximum value.
  @Prop({ type: Number, default: Infinity })
  readonly max!: number;

  // The amount to increment/decrement by.
  @Prop({ type: Number, default: 1 })
  readonly step!: number;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  get isMinusDisabled(): boolean {
    // Disable if the current value is less than or equal to the minimum.
    return this.value <= this.min || this.disabled;
  }

  get isPlusDisabled(): boolean {
    // Disable if the current value is greater than or equal to the maximum.
    return this.value >= this.max || this.disabled;
  }

  increment(): void {
    const newValue = this.value + this.step;
    // Emit the new value, ensuring it doesn't exceed the max.
    this.$emit('input', Math.min(newValue, this.max));
  }

  decrement(): void {
    const newValue = this.value - this.step;
    // Emit the new value, ensuring it doesn't go below the min.
    this.$emit('input', Math.max(newValue, this.min));
  }

  /**
   * Handles direct user input into the text field.
   * It sanitizes the input to only allow numbers.
   */
  handleInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    // Remove any non-digit characters.
    const sanitized = inputElement.value.replace(/\D/g, '');
    // Update the visual input value immediately for responsiveness.
    inputElement.value = sanitized;

    // If the sanitized value is a valid number, emit it.
    if (sanitized !== '') {
      const numericValue = parseInt(sanitized, 10);
      // We don't clamp the value here while typing, we do it on blur.
      this.$emit('input', numericValue);
    }
  }

  /**
   * Handles the blur event (when the user clicks away).
   * This is where we clamp the value to the min/max bounds.
   */
  handleBlur(): void {
    let finalValue = this.value;

    if (finalValue < this.min) {
      finalValue = this.min;
    }
    if (finalValue > this.max) {
      finalValue = this.max;
    }

    if (!this.value) {
      finalValue = 1;
    }

    // If the value was adjusted, emit the final, corrected value.
    if (finalValue !== this.value) {
      this.$emit('input', finalValue);
    }
  }
}
